import React from "react";
import { useLegalTranslation } from "@tablemint/i18n";
import { motion } from "framer-motion";

const PrivacyPolicy = () => {
  const { t } = useLegalTranslation();

  return (
    <div className="container mx-auto px-4 py-12 max-w-4xl">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl font-bold mb-8 text-center">
          {t("privacy.title")}
        </h1>

        <div className="bg-white shadow-md rounded-lg p-6 mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            {t("privacy.intro.title")}
          </h2>
          <p className="mb-4">{t("privacy.intro.description")}</p>
          <p className="mb-4">{t("privacy.intro.effective")}</p>
        </div>

        <div className="bg-white shadow-md rounded-lg p-6 mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            {t("privacy.collection.title")}
          </h2>
          <p className="mb-4">{t("privacy.collection.description")}</p>
          <ul className="list-disc pl-5 mb-4">
            <li className="mb-2">{t("privacy.collection.item1")}</li>
            <li className="mb-2">{t("privacy.collection.item2")}</li>
            <li className="mb-2">{t("privacy.collection.item3")}</li>
            <li className="mb-2">{t("privacy.collection.item4")}</li>
          </ul>
        </div>

        <div className="bg-white shadow-md rounded-lg p-6 mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            {t("privacy.use.title")}
          </h2>
          <p className="mb-4">{t("privacy.use.description")}</p>
          <ul className="list-disc pl-5 mb-4">
            <li className="mb-2">{t("privacy.use.item1")}</li>
            <li className="mb-2">{t("privacy.use.item2")}</li>
            <li className="mb-2">{t("privacy.use.item3")}</li>
            <li className="mb-2">{t("privacy.use.item4")}</li>
          </ul>
        </div>

        <div className="bg-white shadow-md rounded-lg p-6 mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            {t("privacy.sharing.title")}
          </h2>
          <p className="mb-4">{t("privacy.sharing.description")}</p>
          <ul className="list-disc pl-5 mb-4">
            <li className="mb-2">{t("privacy.sharing.item1")}</li>
            <li className="mb-2">{t("privacy.sharing.item2")}</li>
            <li className="mb-2">{t("privacy.sharing.item3")}</li>
          </ul>
        </div>

        <div className="bg-white shadow-md rounded-lg p-6 mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            {t("privacy.cookies.title")}
          </h2>
          <p className="mb-4">{t("privacy.cookies.description")}</p>
          <p className="mb-4">{t("privacy.cookies.management")}</p>
        </div>

        <div className="bg-white shadow-md rounded-lg p-6 mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            {t("privacy.security.title")}
          </h2>
          <p className="mb-4">{t("privacy.security.description")}</p>
        </div>

        <div className="bg-white shadow-md rounded-lg p-6 mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            {t("privacy.rights.title")}
          </h2>
          <p className="mb-4">{t("privacy.rights.description")}</p>
          <ul className="list-disc pl-5 mb-4">
            <li className="mb-2">{t("privacy.rights.item1")}</li>
            <li className="mb-2">{t("privacy.rights.item2")}</li>
            <li className="mb-2">{t("privacy.rights.item3")}</li>
            <li className="mb-2">{t("privacy.rights.item4")}</li>
          </ul>
        </div>

        <div className="bg-white shadow-md rounded-lg p-6 mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            {t("privacy.changes.title")}
          </h2>
          <p className="mb-4">{t("privacy.changes.description")}</p>
        </div>

        <div className="bg-white shadow-md rounded-lg p-6 mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            {t("privacy.contact.title")}
          </h2>
          <p className="mb-4">{t("privacy.contact.description")}</p>
          <p className="mb-4">
            {t("privacy.contact.email")}:{" "}
            <a
              href="mailto:contact@tablemint.app"
              className="text-primary hover:underline"
            >
              contact@tablemint.app
            </a>
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default PrivacyPolicy;
